<template >
<div class="container">
  <div class="header">
    <info-tip 
      :tip="shortcutKeyCodeLabel"
      :show-icon="false"
      class="pull-right"
    >
      <button  class="btn btn-carma btn-square" @click="addRow">
        <i class="fas fa-plus"></i> Add Category
      </button>
    </info-tip>
  </div>
  <div class="card clearfix">
    <datatable ref="table" :data="datatable" labelAdd="Add Categories" :updatingRow="updatingRowId" :loading="tableLoading" />
    <div class="loading-next-page" v-if="loadingNextPage"><loader /></div>
    <!-- <div class="add-category">
      <span class="span-add-row" @click="addRow">
        <i class="fas fa-plus button btn-primary" aria-hidden="true"></i>
        <b>Add category</b>
      </span>
    </div> -->

    <side-panel v-if="showDeleteCategory" :onClose="closePanel">
      <template>
        <load-content :loading="category.isBusy">
          <confirm-delete
            :label="deleteCategoryObj.name"
            :onDelete="() => removeCategory(deleteCategoryObj)"
          />
        </load-content>
      </template>
    </side-panel>

    <side-panel v-if="showCreateCategory" :onClose="closePanel">
      <form-renderer
          :loading="category.isBusy"
          id="add-category-form"
          title="categories.form.create.title"
          submitButtonLabel="categories.form.create.save"
          :fields="['name','category_type_id']"
          :fieldsAdditions="{category_type_id: {options:categoryTypes, searchable: true }}"
          formGroupClass="form-group-full"
          :errors="formCategoryCreateErrors"
          @onSave="addCategory"
      />
    </side-panel>

  </div>
  <div v-if="selectedRows.length > 0" class="datatable-bulk-actions">
    <span>{{selectedLabel}} Selected</span>
    <div class="actions">
      <div class="action btn-primary" @click="onBulk('delete')">Delete</div>
    </div>
  </div>
  <side-panel v-if="bulkDeleteOpen" :onClose="closePanel">
      <template>
        <load-content :loading="isBusy">
          <confirm-delete
              :label="selectedLabel"
              :bulk="true"
              :onDelete="onBulkDelete"
          />
        </load-content>
      </template>
    </side-panel>

  <side-panel v-if="updateError" :onClose="cancelUpdate">
    <load-content :loading="category.isBusy">
      <confirm-action
        :title="$t('categories.form.errors.confirmation_required')"
        :message="updateErrorMessage"
        @confirm="confirmUpdate"
        @cancel="cancelUpdate"
      />
    </load-content>
  </side-panel>
</div>
</template>
<script>
import _ from "lodash";
import DataTable from "../../components/datatable";
import InputSelect from "../form-components/input-select";
import Loader from "../loader";
import LoadContent from "../../components/load-content";
import SidePanel from '../side-panel';
import ConfirmDelete from "../confirm-delete";
import ConfirmAction from "../confirm-action";
import FormRenderer from "../form-renderer";
import { FIELD_TYPE, CATEGORY_TYPES, CATEGORIES } from "../../config/const";
import { propsForMixin } from "../../helpers/application";
import runShortcut from "../../mixins/shortcuts"
import { inputErrors } from "../../helpers/inputErrorHelper";
import { mapState, mapActions } from "vuex";
import moment from 'moment';
import InfoTip from "../info-tip";

export default {
  name: "Categories",
  components: {
    datatable: DataTable,
    FormRenderer,
    SidePanel,
    ConfirmDelete,
    Loader,
    LoadContent,
    InfoTip,
    ConfirmAction
  },
  computed: {
    ...mapState({
      projectSetup: state => state.projectSetup.projectSetup,
      // categories: state => state.projectSetup.projectSetup.data ? state.projectSetup.projectSetup.data.categories : [],
      categories: state => state.admin.categories.categories.data,
      isBusy: state => state.admin.categories.categories.isBusy,
      category: state => state.admin.categories.category
    }),
    categoryTypes() {
      let types = [];
      const self = this;

      types = this.projectSetup.data.cat_type_select.filter(dt => dt.name !== 'organization').map(dt => (
        {
          value: dt.id,
          label: self.$t(`categories.types.${dt.name}`)
        }
      ));

      return types;
    },
    tableLoading() {
      return this.isBusy === true && this.pagination.page === 1;
    },
    loadingNextPage() {
      return this.isBusy === true && this.pagination.page > 1;
    },
    selectedLabel() {
      return `${this.selectedRows.length} ${
        this.selectedRows.length == 1 ? "Category" : "Categories"
      }`;
    },
    datatable() {
      const self = this;
      const { categories } = this;

      let body = [];
      if (categories) {
        body = categories.data;
      }

      const data = {
        custom_components: {
            "input-select": InputSelect
          },
        columns: [
          {
            key: "id",
            label: ""
          },
          {
            key: "name",
            label: this.$t('categories.labels.name.title'),
            class: 'min-width-200',
            input: {
              name: "name",
              type: FIELD_TYPE.INPUT,
              styleNames: { color: "#ec9148", border: "none", outline: 'none' },
              placeholder: "category name",
              onBlur: function(value, key, row) {
                self.updateRow(value, key, row);
              }
            },
            
            disableKey: 'scoring_default',
            orderable: true
          },
          {
            key: "category_type_id",
            label: self.$t('categories.labels.category_type.title'),
            orderable: true,
            render: (row) => {
              const categories = this.projectSetup.data.cat_type_select.filter(option => option.name !== 'organization').map(option => ({
                value: option.id,
                label: self.$t(`categories.types.${option.name}`),
                }));
                if (row.category_type_id === CATEGORY_TYPES.ORGANIZATION) {
                  return <span class="no-selectable-type">{self.$t('categories.types.organization')}</span>
                } else {
                  return (
                  <InputSelect
                    name={"row_" + row.id + "_" + row.category_type_id}
                    value={row.category_type_id}
                    options={categories}
                    searchable={true}
                    multiple={false}
                    allowEmpty={false}
                    disabled={row.scoring_default}
                    placeholder={"Select a category type"}
                    class={"datatable-input-select datatable-input-select--fixed"}
                    onChange={(value) => this.updateRow(value, 'category_type_id', row)}
                  />
              )
                }
            },
            // input: {
            //   name: "category_type_id",
            //   type: FIELD_TYPE.SELECT,
            //   options: this.projectSetup.data.cat_type_select.filter(option => option.name !== 'organization').map(option => ({
            //     value: option.id,
            //     label: self.$t(`categories.types.${option.name}`)
            //   })),
            //   searchable: true,
            //   multiple: false,
            //   placeholder: "Select a category type",
            //   onChange: function(value, key, row) {
            //     self.updateRow(value, key, row);
            //   },
            // },
          },
          {
            key: "required",
            label: self.$t('categories.labels.required.title'),
            orderable: true,
            input: {
              name: "required",
              id: "required",
              type: FIELD_TYPE.CHECKBOX,
              onChange: function(value, key, row) {
                self.updateRow(value, key, row);
              }
            },
            disableKey: 'scoring_default'
          },
          {
            key: "cardinality",
            label: self.$t('categories.labels.cardinality.title'),
            orderable: true,
            input: {
              name: "cardinality",
              type: FIELD_TYPE.SELECT,
              options: this.projectSetup.data.cardinality_options.map(option => ({
                value: option.id,
                label: option.option
              })),
              searchable: true,
              multiple: false,
              allowEmpty: false,
              placeholder: "Select a cardinality",
              onChange: function(value, key, row) {
                self.updateRow(value, key, row);
              }
            },
            disableKey: 'scoring_default'
          },
          {
            key: "record_tone",
            label: self.$t('categories.labels.record_tone.title'),
            orderable: true,
            input: {
              name: "record_tone",
              id: "record_tone",
              type: FIELD_TYPE.CHECKBOX,
              onChange: function(value, key, row) {
                self.updateRow(value, key, row);
              }
            },
            disableKey: 'scoring_default'
          },
          {
            key: "dynamic",
            label: self.$t('categories.labels.dynamic.title'),
            orderable: true,
            input: {
              name: "dynamic",
              id: "dynamic",
              type: FIELD_TYPE.CHECKBOX,
              onChange: function(value, key, row) {
                self.updateRow(value, key, row);
              }
            },
            disableKey: 'scoring_default'
          },
          {
            key: "article_features",
            label: self.$tc('categories.labels.article_features.title', 2),
            orderable: true,
            input: {
              name: "article_features",
              id: "article_features",
              type: FIELD_TYPE.CHECKBOX,
              onChange: function(value, key, row) {
                self.updateRow(value, key, row);
              }
            },
            disableKey: 'scoring_default'
          },
          {
            key: "affects_score",
            label: self.$t('categories.labels.affects_score.title'),
            tooltip: self.$t('categories.labels.affects_score.description'),
            input: {
              name: "affects_score",
              id: "affects_score",
              type: FIELD_TYPE.CHECKBOX,
              onChange: function(value, key, row) {
                if (value === false) {
                  self.updateRow(false, ['include_in_score', 'affects_score'], row);
                }
                else {
                  self.updateRow(value, key, row);
                }
              }
            },
            disableKey: 'scoring_default'
          },
          {
            key: "include_in_score",
            label: self.$t('categories.labels.include_in_score.title'),
            input: {
              name: "include_in_score",
              id: "include_in_score",
              type: FIELD_TYPE.CHECKBOX,
              onChange: function(value, key, row) {
                if (value === true) {
                  self.updateRow(true, ['include_in_score', 'affects_score'], row);
                }
                else {
                  self.updateRow(value, key, row);
                }
              }
            },
            disableKey: 'scoring_default'
          },
          {
            key: "hidden_on_insight",
            label: self.$t('categories.labels.hidden_on_insight.title'),
            input: {
              name: "hidden_on_insight",
              id: "hidden_on_insight",
              type: FIELD_TYPE.CHECKBOX,
              onChange: function(value, key, row) {
                self.updateRow(value, key, row);
              }
            }
          },
          {
            key: "custom_color",
            label: self.$t('categories.labels.custom_color.title'),
            tooltip: self.$t('categories.labels.custom_color.description'),
            input: {
              name: "custom_color",
              type: FIELD_TYPE.COLOR,
              onChange: function(value, key, row) {
                const color = value.hex || value;
                self.updateRow(color, key, row);
              },
              swatchSize: "30",
              triggerStyle: {
                width: "14px",
                height: "14px",
                borderRadius: "3px"
              },
              colors: "text-advanced",
              popoverTo: "left"
            },
            disableKey: 'scoring_default'
          },
          {
            key: "allow_association",
            label: self.$t('categories.labels.allow_association.title'),
            input: {
              name: "allow_association",
              id: "allow_association",
              type: FIELD_TYPE.CHECKBOX,
              onChange: function(value, key, row) {
                self.updateRow(value, key, row);
              }
            }
          },
          // {
          //   key: "created_at",
          //   label: self.$t('categories.labels.created_at.title'),
          //   orderable: true,
          //   render: (row) => {
          //     const date = moment
          //     return (
          //       <span>{row.created_at}</span>
          //     )
          //   }
          // }
        ],
        body,
        resizable: true,
        stickyHeader:false,
        order: {
          column: self.pagination.order,
          direction: self.pagination.sort,
          onChange: function(column, direction) {          
            self.onSortTable({ order: column, sort: direction });
          }
        },
        fixedColumns: {
            enabled: true,
            fixedColumnsLeft: 2,
            widths: [60, 280]
          },
        // bulkActions: {
        //   enabled: true,
        //   onSelect: function(rows) {
        //     self.selectedRows = rows;
        //   }
        // },
        addRow: {
          enabled: categories && categories.data && categories.data.length > 5,
          label: self.$t('categories.form.create.title'),
          onClick: () => self.addRow()
        },
        removeRow: {
          enabled: true,
          disableKey: 'scoring_default',
          onClick: (row) => {
            self.showDeleteCategory = true;
            return {
              ...self.deleteCategoryObj = row
            }
          }
        },
        bulkActions: {
          enabled: true,
          disableKey: 'scoring_default',
          onSelect: function(rows) {
            self.selectedRows = rows;
          }
        }
      }

      return data;
    },
    updateErrorMessage() {
      if (this.updateError && this.updateError.message) {
        if (this.updateError.message === CATEGORIES.ERRORS.TAGS_IN_USE) {
          const count = this.updateError.data.articles_count;
          return this.$tc("categories.form.errors." + this.updateError.message, count, { count: count });
        } else {
          return this.$t("categories.form.errors." + this.updateError.message);
        }
      }
      return "";
    }
  },
  watch: {
    "projectSetup.isReady": {
      handler(value){ 
        this.isReady = value
      },
      deep: true
    },
    "projectSetup.isBusy": {
      handler(value){ 
        if (!value) this.updatingRowId = null
      },
      deep: true
    },
    pagination: {
      handler(newValue){        
        const { pagination, projectId } = this;
        this.getCategories({ projectId, pagination });
      },
      deep: true
    },
    formErrors: {
      handler(value){
          value && import('vue').then(v => {
            v.default.notify({
              group: "store_notifications",
              type: "error",
              text: value
            })
          });
      },
      deep: true
    }
  },
  created: async function() {
    // const projectUid = this.$route.params.project_uid;
    // this.getprojectSetup({ projectUid })
    // this.isReady = true;

    const { projectId, pagination } = this;
    this.getCategories({  projectId, pagination});
    // this.scroll();

    this.$nextTick(() => {
      this.scroll();
    });
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    ...mapActions({
      getCategories: "admin/categories/getCategories",
      createCategory: "admin/categories/createCategory",
      updateCategory: "admin/categories/updateCategory",
      deleteCategory: "admin/categories/deleteCategory",
      deleteBulkCategory: "admin/categories/deleteBulkCategory",
      getprojectSetup: "projectSetup/getprojectSetup"
    }),
    handleScroll: function() {
      this.scroll();
    },
    resetPagination() {
      const { pagination } = this;
      this.pagination = {
        ...pagination,
        order: 'created_at',
        sort: 'desc',
        page: 1
      }
    },
     onBulk: function(action){
      if (action == "delete") {
        this.bulkDeleteOpen = true;
      }
    },
    closePanel: function() {
      this.showCreateCategory = false;
      this.showDeleteCategory = false;
      this.bulkDeleteOpen = false;
      this.formCategoryCreateErrors = [];
      this.selectedRows = [];
      this.updatingRowId = null;
      this.updateError = null;
    },
    onSortTable: async function({ order, sort }) {
      const pagination = {
        ...this.pagination,
        order,
        sort,
        page: 1,
      }
      this.pagination = pagination;
    },
    buildRenderOptions: function() {
      return {};
    },
    addRow() {
      this.showCreateCategory = true;
    },
    onBulkDelete() {
      const {projectId, selectedRows: bulkTags, resetPagination, deleteBulkCategory, closePanel} = this;
      deleteBulkCategory({ projectId, bulkTags}).then(r =>{
          closePanel();
          resetPagination();
      })
    },
    addCategory(category) {
      const projectId = this.projectId;
      this.formCategoryCreateErrors = [];
      this.createCategory({ projectId, category }).then(r => {
        if (r.error) {
          this.formCategoryCreateErrors.push(r.error);
        }
        else {
          this.showCreateCategory = false;
          this.resetPagination();
        }
      });
    },
    removeCategory: function(row) {
      const { projectId } = this;
      const categoryId = this.deleteCategoryObj.id;
      this.deleteCategory({ projectId, categoryId }).then(r => {
        this.showDeleteCategory = false;
        this.resetPagination();
      });
    },
    updateRow(value, key, row, confirm = false) {
      if (row[key] == value) {
        return;
      }
      
      this.formErrors = null;
      if (key === "name") {
        this.formErrors = this.inputErrors(value, "not_null", "Name");
      }

      if (!this.formErrors) {
        let category = {
          id: row.id
        }

        if (_.isArray(key)) {
          key.forEach(k => category[k] = value);
        }
        else {
          category[key] = value;
        }

        if (confirm) {
          category.confirm = true;
        }

        const { projectId } = this;
        this.updatingRowId = category.id;
        this.updateCategory({ projectId, category }).then(r => {
          const res = r.response;
          if (res && res.status === 400) {
            this.updateError = {
              requestData: { value, key, row },
              message: res.data.message,
              data: res.data.data
            }
          } else {
            this.closePanel();
          }
        });
      }
    },
    cancelUpdate () {
      this.closePanel();
    },
    confirmUpdate () {
      const data = this.updateError.requestData;
      this.updateRow(data.value, data.key, data.row, true);
    },
    scroll: function() {
      const { projectId, categories, isBusy } = this;

      if (categories) {
        const { currentPage, totalPages } = categories.pagination;

        if (currentPage < totalPages) {
          const wHeight = window.innerHeight;
          const {
            top,
            bottom,
            height
          } = this.$refs.table.$el.getBoundingClientRect();
          const margin = 100;

          if (top * -1 + wHeight >= height - margin && isBusy == false) {
            const { pagination } = this;
            this.pagination = {
              ...pagination,
              page: pagination.page + 1
            }
          }
        }
      }
    },
    inputErrors
  },
  data: function() {
    const projectUid = this.$route.params.project_uid;
    return {
      projectUid,
      projectId: projectUid,
      isReady: false,
      formErrors: null,
      load: false,
      pagination: {
        page: 1,
        perPage: 20,
        order: "created_at",
        sort: "desc"
      },
      showCreateCategory: false,
      showDeleteCategory: false,
      deleteCategoryObj: {},
      updatingRowId: null,
      CATEGORY_TYPES,
      formCategoryCreateErrors: [],
      selectedRows: [],
      bulkDeleteOpen: false,
      updateError: null
    };
  },
  mixins: [propsForMixin, runShortcut('addTag')]
};
</script>

<style lang="scss" scoped>
  @import "../../styles/components/_datatable_bulk_actions.scss";
  
  .span-add-row {
    cursor: pointer;
  }

  .loading-next-page {
    position: relative;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>